import Vue from 'vue'
import {dd,store,app} from 'systems/imports'

import BaseProcessor from 'processor/BaseProcessor'
import API from 'api/Auth'

/**
 */
class Auth extends BaseProcessor{
  static getClassName(){ return 'Auth' }

  /**
   */
  static login(input){
    return new Promise(function(resolve, reject) {
      API.login(input)
        .then((res)=>{
          //仮登録時のデータは削除しておく
          if(store.get('provisionalUser')){
            store.remove('provisionalUser')
          }
          store.set("token",res.token)
          store.set("user",res.user)
          return resolve({status:"ok",data:{token:res.token,user:res.user} })
          //return resolve({status:"ok",data})
        }).catch((e)=>{
        switch(e.name){
          case "invalid_credentials":
            return resolve({status:"ng",data:{},apiErrorI18nKey:"error[4][6]"})
        }
      })
    });
  }

  /**
   */
  static logout(){
    return new Promise(function(resolve, reject) {
      API.logout()
        .then((res)=>{
          return resolve({status:"ok",data:{} })
        }).catch((e)=>{
          switch(e.name){
            case "token_invalid":
            case "token_not_provided":
              return resolve({status:"ng",data:{},apiErrorI18nKey:""})
          }
      })
    });
  }
}

export default Auth



// WEBPACK FOOTER //
// ./src/processor/Auth.js